import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LMTransactionService } from './lm-transaction.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    LMTransactionService
  ]
})
export class TransactionModule { }
